import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../../hooks'
import { DatePicker } from '../../../../../DateTime'
import { FormikField } from '../../../../../Formik'
import { LISTING_FORM_FIELD_NAME_AVAILABLE_FROM } from '../../../../../RentalPortalListing'

function AvailableFromField({ isLoading }) {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen()

  return (
    <FormikField
      Component={DatePicker}
      borderless={!isMobileScreenSize}
      fieldComponentProps={{
        isLoading,
        label: `${t('RentalPortal.ListingFormAvailableFromLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      name={LISTING_FORM_FIELD_NAME_AVAILABLE_FROM}
      placeholder={t('RentalPortal.ListingFormAvailableFromPlaceholderKey')}
    />
  )
}

export default AvailableFromField
